import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "../../utils/config";
import { t, tx } from "@transifex/native";
import { T, useT } from "@transifex/react";
import LoadingOverlay from "react-loading-overlay";

const AccountPending = () => {
  tx.init({
    token: "1/b764923cd80f817a0b810d8688e7c8f4dc7c75eb",
  });
  var segment_str = window.location.pathname;
  var segment_array = segment_str.split("/");
  var user_language = segment_array.pop();
  const [loading, setLoading] = useState(false);

  tx.setCurrentLocale(user_language);
  return (
    <LoadingOverlay active={loading} spinner text={t('Processing')}>
      <div class="main-container container user-redirect-pages">
        <div id="main-title">
          <div class="float-left title-subline">
            <h1 class="page-header">
              eView<sup>&reg;</sup> - <T _str="We thank you for your request." />
            </h1>
          </div>
        </div>
      <p></p>
        <p>
          {" "}
          <T _str="It is pending approval and will be validated within the next 48 hours." />
        </p>
        <a class="standalone-link btn btn-success" href="/">
          <T _str="Back to Login" />{" "}
        </a>
      </div>
    </LoadingOverlay>
  );
};
export default AccountPending;
